import React from 'react';
import {
  expEnumOptions,
  expLvlOptions,
  jobShiftOptions,
  salaryPeriodOptions,
  workPrefOptions,
} from '../../utils/constants';
import InputField from '../ui/InputField';
import RichTextEditor from '../ui/RichTextEditor';
import {SelectFieldHookForm} from '../ui/SelectField';
import TextArea from '../ui/TextArea';
import {allCountries, findStateFromCountry} from '../../utils/countrystate';
import FormItem from './FormItem';

const JobDetailsForm = ({jobFormHook}) => {
  const {
    register,
    control,
    formState: {errors},
    watch,
  } = jobFormHook;

  const allStatesOfSelectedCountry = findStateFromCountry(
    watch('country') || '',
  );

  return (
    <div className="flex flex-col gap-6">
      <FormItem label="Job Title" htmlFor="title">
        <InputField
          placeholder="Enter Job title"
          id="title"
          {...register('title')}
          error={errors?.title?.message}
        />
      </FormItem>

      <FormItem label="Job description" htmlFor="description">
        <RichTextEditor
          name="description"
          control={control}
          error={errors?.description?.message}
        />
      </FormItem>

      <FormItem
        label="Pitch (Company information to attract candidates)"
        htmlFor="companyInfo"
      >
        <TextArea
          rows="7"
          id="companyInfo"
          {...register('companyInfo')}
          error={errors?.['companyInfo']?.message}
        />
      </FormItem>

      <div className="grid grid-cols-3 gap-5">
        <FormItem label="experience level" htmlFor="expLevel">
          <SelectFieldHookForm
            placeholder="selelct experience level"
            id="expLevel"
            name="expLevel"
            className="w-full bg-white"
            control={control}
            options={expLvlOptions}
            error={errors?.expLevel?.message}
          />
        </FormItem>

        <FormItem label="Job Type" htmlFor="jobType">
          <SelectFieldHookForm
            placeholder="selelct experience level"
            id="jobType"
            name="jobType"
            className="w-full bg-white"
            control={control}
            options={workPrefOptions}
            error={errors?.jobType?.message}
          />
        </FormItem>

        <FormItem label="Job shift" htmlFor="jobShift">
          <SelectFieldHookForm
            placeholder="selelct job type"
            id="jobShift"
            name="jobShift"
            className="w-full bg-white"
            control={control}
            options={jobShiftOptions}
            error={errors?.jobShift?.message}
          />
        </FormItem>
      </div>

      <div className="grid grid-cols-2 gap-5">
        <FormItem label="Required experience" htmlFor="requiredExp">
          <SelectFieldHookForm
            placeholder="select salary period"
            id="requiredExp"
            name="requiredExp"
            className="w-full bg-white"
            control={control}
            options={expEnumOptions}
            error={errors?.requiredExp?.message}
          />
        </FormItem>

        <FormItem label="Qualifications" htmlFor="qualifications">
          <InputField
            placeholder="enter your qualifications"
            id="qualifications"
            {...register('qualifications')}
            error={errors?.qualifications?.message}
          />
        </FormItem>
      </div>

      <div className="grid grid-cols-2 gap-5">
        <div className="grid grid-cols-2 gap-2">
          <FormItem Item label="Salary Period" htmlFor="salaryPeriod">
            <SelectFieldHookForm
              placeholder="select salary period"
              id="salaryPeriod"
              name="salaryPeriod"
              className="w-full bg-white"
              control={control}
              options={salaryPeriodOptions}
              error={errors?.salaryPeriod?.message}
            />
          </FormItem>

          <FormItem label="Salary" htmlFor="salary">
            <InputField
              type="number"
              placeholder="enter your salary"
              id="salary"
              {...register('salary')}
              error={errors?.salary?.message}
            />
          </FormItem>
        </div>
        <FormItem label="Vacancies" htmlFor="vacancies">
          <InputField
            type="number"
            placeholder="enter no. of vacancies"
            id="vacancies"
            {...register('vacancies')}
            error={errors?.vacancies?.message}
          />
        </FormItem>
      </div>

      <div className="grid grid-cols-3 gap-5">
        <FormItem label="Country">
          <SelectFieldHookForm
            placeholder="select country"
            id="country"
            name="country"
            className="w-full bg-white"
            control={control}
            options={allCountries}
            error={errors?.country?.message}
          />
        </FormItem>
        <FormItem label="State">
          <SelectFieldHookForm
            placeholder="select state"
            id="state"
            name="state"
            className="w-full bg-white"
            control={control}
            options={allStatesOfSelectedCountry}
            error={errors?.country?.message}
            noOptionsMessage={() => 'Please select country first'}
          />
        </FormItem>
        <FormItem label="City" htmlFor="city">
          <InputField
            id="city"
            placeholder="enter city"
            {...register('city')}
            error={errors?.city?.message}
          />
        </FormItem>
      </div>

      <div className="grid grid-cols-2 gap-5">
        <FormItem label="Requirements" htmlFor="requirements">
          <RichTextEditor
            name="requirements"
            control={control}
            error={errors?.requirements?.message}
          />
        </FormItem>

        <FormItem label="Responsiblities" htmlFor="responsiblities">
          <RichTextEditor
            name="responsiblities"
            control={control}
            error={errors?.responsiblities?.message}
          />
        </FormItem>
      </div>
    </div>
  );
};

export default JobDetailsForm;
